import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import { divider, primary } from '../../Styles/Colours';
import styles from './CreatingMedicationListPlaceholder.module.scss';
import CreatingMedicationListGraphic from '../../Images/creating-medication-list.svg';

const ColorLinearProgress = withStyles({
    colorPrimary: {
        backgroundColor: divider
    },
    barColorPrimary: {
        backgroundColor: primary
    }
})(LinearProgress);

export const CreatingMedicationListPlaceholder: React.FC = () => {
    return (
        <div className={styles.body}>
            <img src={CreatingMedicationListGraphic} alt='' className={styles.main} />
            <div className={styles.title}>
                Creating your <em>medication list</em>
            </div>
            <div className={styles.info}>We&apos;re creating your medication list</div>
            <ColorLinearProgress className={styles.progress} />
        </div>
    );
};
